import React from 'react';
import { motion } from 'framer-motion';
import { FiFileText, FiDollarSign, FiTrendingUp, FiUsers } from 'react-icons/fi';

const ServiceCards = () => {
  const services = [
    {
      icon: <FiFileText size={48} />,
      title: "Tax Prep",
      color: "bg-blue-100",
      textColor: "text-blue-800",
      iconColor: "text-blue-600"
    },
    {
      icon: <FiDollarSign size={48} />,
      title: "Financial Services",
      color: "bg-green-100",
      textColor: "text-green-800",
      iconColor: "text-green-600"
    },
    {
      icon: <FiTrendingUp size={48} />,
      title: "Investments",
      color: "bg-amber-100",
      textColor: "text-amber-800",
      iconColor: "text-amber-600"
    },
    {
      icon: <FiUsers size={48} />,
      title: "Consulting",
      color: "bg-purple-100",
      textColor: "text-purple-800",
      iconColor: "text-purple-600"
    }
  ];

  const containerVariants = {
    hidden: {},
    visible: {transition: {staggerChildren: 0.2}}
  };

  const itemVariants = {
    hidden: {opacity: 0, y: 20},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6}}
  };

  return (
    <section className="py-16 bg-white relative -mt-28 z-10">
      <div className="container mx-auto px-4">
        <motion.div 
          className="grid grid-cols-2 md:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{once: true, margin: "-100px"}}
        >
          {services.map((service, index) => (
            <motion.div 
              key={index}
              className={`${service.color} rounded-xl shadow-lg p-6 flex flex-col items-center justify-center text-center h-48 transform transition-transform hover:scale-105`}
              variants={itemVariants}
            >
              <div className={`mb-4 ${service.iconColor}`}>
                {service.icon}
              </div>
              <h3 className={`text-xl font-semibold ${service.textColor}`}>
                {service.title}
              </h3>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceCards;